import React from 'react';
import { ScionTimelock, useCallsSubgraph } from '@sc1/common';

import { Box, Card, Heading } from '../core';
import { useChain } from '@sc1/common/hooks';

import { ExecutableTx } from './ExecutableTx';
import type { CardProps } from 'theme-ui';

interface ExecutorTableProps extends CardProps {
  timelock: ScionTimelock | undefined;
  disabled: boolean;
}

export const ExecutorTable = ({
  timelock,
  disabled,
  ...rest
}: ExecutorTableProps): JSX.Element | null => {
  const chain = useChain();
  const { data: allTxs } = useCallsSubgraph(chain);
  return (
    <Card bg="hinted" {...rest}>
      <Heading as="h2" mb={4}>
        Proposed Transactions
      </Heading>
      <Box sx={{ fontSize: 1, maxHeight: '350px', overflow: 'auto' }}>
        {allTxs?.calls?.length ? (
          <Box as="table" variant="boxes.table">
            <Box as="thead">
              <Box as="tr">
                <Box as="th">Target</Box>
                <Box as="th">Function</Box>
                <Box as="th">Args</Box>
                <Box as="th">Status</Box>
                <Box as="th">Actions</Box>
              </Box>
            </Box>
            <Box as="tbody">
              {allTxs?.calls?.map((call) => (
                <ExecutableTx
                  key={call.id}
                  call={call}
                  chain={chain}
                  timelock={timelock}
                  disabled={disabled}
                />
              ))}
            </Box>
          </Box>
        ) : (
          'No Scheduled Txs...'
        )}
      </Box>
    </Card>
  );
};
